import { render, staticRenderFns } from "./VSMSStats.vue?vue&type=template&id=8a87570a&"
import script from "./VSMSStats.vue?vue&type=script&lang=js&"
export * from "./VSMSStats.vue?vue&type=script&lang=js&"
import style0 from "./VSMSStats.vue?vue&type=style&index=0&id=8a87570a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports